export enum UserProductBillableType {
  Billable = 'Billable',
  NoneBillable = 'NoneBillable',
}
